import { render, staticRenderFns } from "./WaitingListCellRendererCustomer.vue?vue&type=template&id=2030b924&scoped=true&"
import script from "./WaitingListCellRendererCustomer.vue?vue&type=script&lang=js&"
export * from "./WaitingListCellRendererCustomer.vue?vue&type=script&lang=js&"
import style0 from "./WaitingListCellRendererCustomer.vue?vue&type=style&index=0&id=2030b924&prod&lang=scss&"
import style1 from "./WaitingListCellRendererCustomer.vue?vue&type=style&index=1&id=2030b924&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2030b924",
  null
  
)

export default component.exports